import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["observer", "button"];

  connect() {
    this.setupObserver();
  }

  disconnect() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  setupObserver() {
    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        // Ocultar botón cuando el elemento observado está visible
        if (entry.isIntersecting) {
          this.buttonTarget.style.display = "none";
        } else {
          this.buttonTarget.style.display = "block";
        }
      },
      {
        threshold: 0,
      }
    );

    this.intersectionObserver.observe(this.observerTarget);
  }
}

